export const BrandConfigPath = {
  BRAND_CONFIG_HOME: "",
  BRAND_CONFIG_ASSETS: "brand-config",
  BRAND_CONFIG_CUSTOMISE: "customise-item",
};
